import script from "./docs.vue?vue&type=script&setup=true&lang=js"
export * from "./docs.vue?vue&type=script&setup=true&lang=js"

import "./docs.vue?vue&type=style&index=0&id=7e676774&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7e676774"]])

export default __exports__